import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Settings() {
  const { isAdmin, isSuperAdmin, user } = useAuth();
  const [tenant, setTenant] = useState(null); const [members, setMembers] = useState([]); const [regime, setRegime] = useState(null);
  useEffect(() => {
    api.get("/tenant/me").then(({ data }) => setTenant(data)).catch(() => {});
    api.get("/dashboard/fiscal_regime").then(({ data }) => setRegime(data)).catch(() => {});
    if (isAdmin) api.get("/tenant/members").then(({ data }) => setMembers(data)).catch(() => {});
  }, [isAdmin, user?.tenant_id]);
  const change = async (mode) => {
    try { await api.post("/dashboard/fiscal_regime", null, { params: { mode } }); setRegime((r) => ({ ...r, mode })); toast.success("Regime atualizado"); }
    catch (error) { toast.error(formatError(error)); }
  };
  return <div className="p-6 lg:p-8 space-y-6" data-testid="settings-page">
    <h1 className="font-display text-3xl font-bold">Configurações</h1>
    <Card className="glass"><CardContent className="p-6 space-y-2"><h2 className="text-xl font-bold">Minha empresa</h2>
      <p>{tenant?.name}</p><p className="text-sm text-muted-foreground">{tenant?.cnpj || "CNPJ não informado"} · {tenant?.status === "ACTIVE" ? "Ativa" : "Suspensa"}</p>
      {isSuperAdmin && <Link className="text-sm underline" to="/admin/tenants">Gerenciar empresas</Link>}
    </CardContent></Card>
    <Card className="glass"><CardContent className="p-6 space-y-4"><h2 className="text-xl font-bold">Regime fiscal</h2>
      <p className="text-sm text-muted-foreground">Simulação fiscal para novas emissões desta empresa.</p><div className="flex gap-3 flex-wrap">
        {[["classic", "Clássico"], ["hybrid", "Transição"], ["reforma", "Reforma"]].map(([mode, label]) => <Button key={mode} variant={regime?.mode === mode ? "default" : "outline"} disabled={!isAdmin} onClick={() => change(mode)}>{label}</Button>)}
      </div></CardContent></Card>
    {isAdmin && <Card className="glass"><CardContent className="p-6 space-y-3"><h2 className="text-xl font-bold">Usuários da empresa</h2>
      <p className="text-sm text-muted-foreground">Convites e permissões são gerenciados pela administração da plataforma.</p>
      {members.map((m) => <div key={m.id} className="flex justify-between border-b border-white/5 py-2"><span>{m.name} · {m.email}</span><span>{m.membership_role === "COMPANY_ADMIN" ? "Administrador" : "Usuário"}</span></div>)}
      {isSuperAdmin && <Link className="text-sm underline" to="/admin/invites">Gerenciar convites</Link>}
    </CardContent></Card>}
  </div>;
}
